import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from 'react';

interface EstablishmentsContextData {
  establishmentsCount: number | undefined;
  setEstablishmentsCount: Dispatch<SetStateAction<number | undefined>>;
}

export const EstablishmentsContext = createContext<
  EstablishmentsContextData | undefined
>(undefined);

const EstablishmentsProvider = ({ children }: { children: ReactNode }) => {
  const [establishmentsCount, setEstablishmentsCount] = useState<
    number | undefined
  >();

  return (
    <EstablishmentsContext.Provider
      value={{
        establishmentsCount,
        setEstablishmentsCount,
      }}
    >
      {children}
    </EstablishmentsContext.Provider>
  );
};

export default EstablishmentsProvider;
